export const filterVars = {
    showAll: "",
    
    weakABV: "&abv_lt=4.6",
    mediumABV: "&abv_gt=4.5&abv_lt=7.5",
    strongABV: "&abv_gt=7.4",

    lowIBU: "&ibu=35",
    mediumIBU: "&ibu_gt=35&ibu_lt=75",
    highIBU: "&ibu_gt=75"
}